module.exports = __webpack_public_path__ + "media/nf_summary.43a83267.mp4";